<template lang="">
  <div>
    <div class="container">
      <div class="main-result">
        <texts  v-if="$store.state.control == 1" title="企业编号:" :value="formItem.incode"></texts><br />
        <texts title="产品编号:" :value="formItem.QRcode"></texts><br />
        <texts title="联系电话:" :value="formItem.phone"></texts><br />
        <texts title="反馈内容:" :value="formItem.text"></texts><br />
        <texts title="反馈时间:" :value="formItem.time"></texts>
      </div>

      <div class="btn">
        <Button
          @click="echo()"
          type="success"
          style="width: 100px; height: 40px"
          >确&nbsp;定</Button
        >
      </div>
    </div>
  </div>
</template>
<script>
import texts from "@/views/text";
export default {
  data() {
    return {
      formItem: {
        incode: "",
        QRcode: "",
        phone: "",
        text: "",
        time: "",
      },
    };
  },
  components: {
    texts,
  },
  props: ["ResultDate"],
  watch: {
    ResultDate(news, olds) {
      console.log(news);
      this.formItem = {
        incode: news.in_code,
        QRcode: news.qr_code,
        phone: news.phone,
        text: news.text,
        time: news.time,
      };
    },
  },
  methods: {
    echo() {
      this.$emit("results", '');
    },
  },
};
</script>
<style scoped>
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
